export const Types = {
  //Get - List
  GET_SUBITENS_LIST_REQUEST: 'GET_SUBITENS_LIST_REQUEST',
  GET_SUBITENS_LIST_SUCCESS: 'GET_SUBITENS_LIST_SUCCESS',
  GET_SUBITENS_LIST_FAIL: 'GET_SUBITENS_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_SUBITENS_LIST: 'SET_UPDATE_SUBITENS_LIST',

  //Store - Add
  POST_SUBITENS_ADD_REQUEST: 'POST_SUBITENS_ADD_REQUEST',
  POST_SUBITENS_ADD_SUCCESS: 'POST_SUBITENS_ADD_SUCCESS',
  POST_SUBITENS_ADD_FAIL: 'POST_SUBITENS_ADD_FAIL',

  //Update - Edit
  PUT_SUBITENS_EDIT_REQUEST: 'PUT_SUBITENS_EDIT_REQUEST',
  PUT_SUBITENS_EDIT_SUCCESS: 'PUT_SUBITENS_EDIT_SUCCESS',
  PUT_SUBITENS_EDIT_FAIL: 'PUT_SUBITENS_EDIT_FAIL',

  //Delete
  DELETE_SUBITENS_DEL_REQUEST: 'DELETE_SUBITENS_DEL_REQUEST',
  DELETE_SUBITENS_DEL_SUCCESS: 'DELETE_SUBITENS_DEL_SUCCESS',
  DELETE_SUBITENS_DEL_FAIL: 'DELETE_SUBITENS_DEL_FAIL',

  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {
  dataList: [],
  loadingList: false,
  errorList: false,
  errorDataList: false,
  dataListUpdate: false,

  loadingAdd: false,
  errorAdd: false,
  errorDataAdd: false,

  loadingEdit: false,
  errorEdit: false,
  errorDataEdit: false,

  loadingDelete: false,
  errorDelete: false,
  errorDataDelete: false,

};

export default function subitens(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Get - List
    case Types.GET_SUBITENS_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        errorList: false,
      };
    case Types.GET_SUBITENS_LIST_SUCCESS:
      return {
        ...state,
        dataList: action.payload,
        loadingList: false,
        errorList: false,
        errorDataList: false
      };
    case Types.GET_SUBITENS_LIST_FAIL:
      return {
        ...state,
        dataList: false,
        loadingList: false,
        errorList: true,
        errorDataList: action.payload,
      };

    case Types.SET_UPDATE_SUBITENS_LIST:
      return {
        ...state,
        dataListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_SUBITENS_ADD_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: false,
      };
    case Types.POST_SUBITENS_ADD_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,
      };
    case Types.POST_SUBITENS_ADD_FAIL:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: true,
        errorDataAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_SUBITENS_EDIT_REQUEST:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: false,
      };
    case Types.PUT_SUBITENS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,
      };
    case Types.PUT_SUBITENS_EDIT_FAIL:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: true,
        errorDataEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_SUBITENS_DEL_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: false,
      };
    case Types.DELETE_SUBITENS_DEL_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,
      };
    case Types.DELETE_SUBITENS_DEL_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: true,
        errorDataDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        dataList: false,
        loadingList: false,
        errorList: false,
        errorDataList: false,
        dataListUpdate: false,

        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,

        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,

        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  //Get - List
  getSubitensListRequest: (payload) => ({
    type: Types.GET_SUBITENS_LIST_REQUEST,
    payload,
  }),
  getSubitensListRequestSuccess: (payload) => ({
    type: Types.GET_SUBITENS_LIST_SUCCESS,
    payload,
  }),
  getSubitensListRequestFail: (payload) => ({
    type: Types.GET_SUBITENS_LIST_FAIL,
    payload,
  }),

  setUpdateSubitens: (payload) => ({
    type: Types.SET_UPDATE_SUBITENS_LIST,
    payload,
  }),

  //Store - Add 
  postSubitensAddRequest: (payload) => ({
    type: Types.POST_SUBITENS_ADD_REQUEST,
    payload,
  }),
  postSubitensAddRequestSuccess: () => ({
    type: Types.POST_SUBITENS_ADD_SUCCESS,
  }),
  postSubitensAddRequestFail: (payload) => ({
    type: Types.POST_SUBITENS_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putSubitensEditRequest: (payload) => ({
    type: Types.PUT_SUBITENS_EDIT_REQUEST,
    payload,
  }),
  putSubitensEditRequestSuccess: () => ({
    type: Types.PUT_SUBITENS_EDIT_SUCCESS,
  }),
  putSubitensEditRequestFail: (payload) => ({
    type: Types.PUT_SUBITENS_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteSubitensDelRequest: (payload) => ({
    type: Types.DELETE_SUBITENS_DEL_REQUEST,
    payload,
  }),
  deleteSubitensDelRequestSuccess: () => ({
    type: Types.DELETE_SUBITENS_DEL_SUCCESS,
  }),
  deleteSubitensDelRequestFail: (payload) => ({
    type: Types.DELETE_SUBITENS_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
